var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tc-section mt-0 tc-bg text-on-screen"},[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }